// src/views/litellm/components/HealthStrip.jsx
import React from "react";
import HeadlineKpiCard from "../../../components/ui-components/HeadlineKpiCard";
import FreshnessTile from "./FreshnessTile";
import { usd, compactNumber } from "../format";

// count renders a small "N active keys · M models" supporting line. Active-key/model counts are
// operational context, not headline decisions, so they live here as quiet metadata rather than
// as two more equal-weight KPI cards (which would imply they matter as much as cost or freshness).
function meta(n, one, many) {
  const v = Number(n) || 0;
  return `${compactNumber(v)} ${v === 1 ? one : many}`;
}

// HealthStrip is the primary KPI row: the four measures a reader actually decides on — cost,
// tokens, events today, and data freshness — as a four-up grid of headline cards, with active
// keys/models demoted to a supporting metadata line beneath.
export default function HealthStrip({ freshness = {}, totals = {}, active = {} }) {
  return (
    <div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <HeadlineKpiCard label="Cost today" value={usd(totals.cost)} />
        <HeadlineKpiCard label="Tokens today" value={compactNumber(totals.tokens)} />
        <HeadlineKpiCard label="Events today" value={compactNumber(totals.events)} />
        <FreshnessTile freshness={freshness} />
      </div>
      <div className="mt-2 text-xs text-text-3">
        {meta(active.api_keys, "active key", "active keys")} · {meta(active.models, "model", "models")}
      </div>
    </div>
  );
}
